<ng-container *transloco="let t">
  @if (itemType() === 'product-with-presentations') {
    <span class="current-price">
      <span class="price-from">{{ t('productList.priceFrom') }}</span>
      {{ price() | currencyFormat }}
    </span>
  } @else if (hasPriceDiscount()) {
    <span class="previous-price">{{ price() | currencyFormat }}</span>
    <span class="current-price">{{ priceDiscount() | currencyFormat }}</span>
  } @else {
    <span class="current-price">{{ price() | currencyFormat }}</span>
  }

  @if (hasHeadline()) {
    <span class="discount-percentage">
      <pxw-tag type="success" size="xs">
        {{ t('product.maxDiscount', { maxDiscount: headlineDiscount() }) }}
      </pxw-tag>
    </span>
  }
</ng-container>
